module.exports = __webpack_public_path__ + "img/178.d7d5c5a3.jpg";